module.exports = __webpack_public_path__ + "img/GSP.cdc5920c.png";